import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const GiveBonusManagementController = Suspendable(
  lazy(() =>
    import('@modules/giveBonus/controller/GiveBonusManagementController').then(
      (module) => ({
        default: module.GiveBonusManagementController,
      })
    )
  )
);

export const GiveBonusManagement: RouteObject[] = [
  {
    path: ROUTES.GIVE_BONUS_MANAGEMENT.ROOT,
    element: <GiveBonusManagementController />,
  },
];
